import {
  Button,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';
import { FSSearchField } from '@/ui/components/FSSearchField';
import { FSDateField } from '@/ui/components/input/FSDateField';
import { FSImageField } from '@/ui/components/input/FSImageField';
import { FSPositionGeocodeField } from '@/ui/components/input/FSPositionGeocodeField';
import { FSRadioGroup } from '@/ui/components/input/FSRadioGroup';
import { FSSelect } from '@/ui/components/input/FSSelect';
import { FSSlider } from '@/ui/components/input/FSSlider';
import { FSTextField } from '@/ui/components/input/FSTextField';

type Inputs = { [key: string]: string };

export function ComponentsFields() {
  const { control } = useForm<Inputs>();

  return (
    <Stack sx={{ width: 500, marginBottom: 5 }}>
      <p>text :</p>
      <FSTextField label="FSTextField" onChange={() => {}} />
      <FSTextField label="FSTextField disabled" onChange={() => {}} disabled />
      <FSTextField
        label="FSTextField disabled"
        onChange={() => {}}
        defaultValue={'dfault value'}
      />
      <FSTextField
        label="FSTextField error"
        defaultValue={'error = true'}
        onChange={() => {}}
        error={true}
      />
      <FSTextField
        label="FSTextField helper text"
        onChange={() => {}}
        helperText="helper text"
      />
      <FSTextField
        label="FSTextField with placehodler"
        onChange={() => {}}
        placeholder="placeholder"
        placeholderColor="#A29BAE"
      />
      <FSTextField label="FSTextField required" onChange={() => {}} required />

      {/* <FSTextField label="FSTextField select" onChange={() => {}} select /> */}
      <FSTextField label="FSTextField select" onChange={() => {}} select>
        <MenuItem value={10}>Ten</MenuItem>
        <MenuItem value={20}>Twenty</MenuItem>
        <MenuItem value={30}>Thirty</MenuItem>
      </FSTextField>
      <SelectWithDefaultValue />
      <FSTextField
        label="FSTextField variant=standard"
        onChange={() => {}}
        variant="standard"
      />

      <p>select :</p>
      <FSSelect
        name="select"
        control={control}
        onBlur={() => {
          console.log('🟦 onBlur FSSelect');
        }}
        onChange={() => {
          console.log('🟦 onChange FSSelect');
        }}
      >
        <MenuItem value={10}>Ten</MenuItem>
        <MenuItem value={20}>Twenty</MenuItem>
        <MenuItem value={30}>Thirty</MenuItem>
      </FSSelect>
      <p>radio group boolean yes no :</p>
      <p> --- (no value)</p>
      <FSRadioGroup
        name="radio"
        control={control}
        // value={true}
        onBlur={() => {
          console.log('🟩 onBlur');
        }}
        onChange={() => {
          console.log('🟥 onChange');
        }}
      />
      <p> --- (value = false)</p>
      <FSRadioGroup
        name="radio2"
        control={control}
        value={false}
        onBlur={() => {
          console.log('🟩 onBlur');
        }}
        onChange={() => {
          console.log('🟥 onChange');
        }}
      />
      <p> --- (value = true)</p>
      <FSRadioGroup
        name="radio3"
        control={control}
        value={true}
        onBlur={() => {
          console.log('🟩 onBlur');
        }}
        onChange={() => {
          console.log('🟥 onChange');
        }}
      />
      <p>checkbox :</p>
      <FormControlLabel
        label={<Typography>checkbox</Typography>}
        control={
          <Checkbox
            checked={false}
            onChange={(_, checked: boolean) =>
              console.log('checkbox checked', checked)
            }
          />
        }
      />
      <FormControlLabel
        label={<Typography>checkbox</Typography>}
        control={
          <Checkbox
            checked={false}
            onChange={(_, checked: boolean) =>
              console.log('checkbox checked', checked)
            }
          />
        }
      />
      <p>slider</p>
      <FSSlider control={control} name="slider" />
      <p>date :</p>
      <FSDateField
        name="date"
        label="Date field"
        value="2021-10-10"
        onChange={(value) => console.log('date changed', value?.toISOString())}
      />
      <p>
        date minDate: 2025-01-15 - maxDate: 2025-01-29 - referenceDate:
        2025-01-20
      </p>
      <FSDateField
        name="date2"
        label="Date field min max"
        minDate={dayjs('2025-01-15')}
        maxDate={dayjs('2025-01-29')}
        referenceDate={dayjs('2025-01-20')}
        onChange={(value) => console.log('date changed', value?.toISOString())}
      />
      <p>date show specific month if value is empty - referenceDate: 2024-03</p>
      <FSDateField
        name="date3"
        label="Date fiel referenceDate"
        referenceDate={dayjs('2024-03')}
        onChange={(value) => console.log('date changed', value?.toISOString())}
      />
      <p>image filed</p>
      <FSImageField
        name="i2"
        value={'https://picsum.photos/200/300'}
        onChange={(image) => console.log(image)}
      />
      <FSImageField name="i3" onChange={(image) => console.log(image)} />
      <FSImageField
        name="i4"
        onChange={(image) => console.log(image)}
        value={''}
      />
      <p>search :</p>
      <FSSearchField label={'search a memeber'} />
      {/* FSPositionGeocodeField */}
      <PositionGeocodeFields />
    </Stack>
  );
}

function PositionGeocodeFields() {
  const [placeGeocodeValue, setPlaceGeocodeValue] =
    useState<PositionGeocode | null>(null);

  const [value, setValue] = useState<PositionGeocode | undefined>(undefined);

  const defaultValue: PositionGeocode = {
    coordinates: [2.294554, 48.858377],
    properties: {
      name: 'Paris',
      address: 'Paris, France',
      city: 'Paris',
      countryCode: 'FR',
    },
  };

  return (
    <>
      <span>position geocode :</span>
      <span>field 1 : simple</span>
      <Typography sx={{ mt: 1, color: '#c863d6ff', fontWeight: 700 }}>
        place data : {JSON.stringify(placeGeocodeValue, null, 2)}
      </Typography>
      <FSPositionGeocodeField
        label="FSPositionGeocodeField"
        onChange={(value) => setPlaceGeocodeValue(value)}
      />
      <span>field 2 : with defaultValue</span>
      <FSPositionGeocodeField
        label="FSPositionGeocodeField"
        defaultValue={defaultValue}
        onChange={(value) => console.log(value)}
      />
      <span>field 3 : fill value on click</span>
      <FSPositionGeocodeField
        label="FSPositionGeocodeField"
        value={value}
        onChange={(value) => console.log(value)}
      />
      <Button
        onClick={() => {
          setValue(defaultValue);
        }}
      >
        fill with existing value Paris .
      </Button>
    </>
  );
}

function SelectWithDefaultValue() {
  const defaultValues: Inputs = {
    select1: '20',
    select2: '20',
    select3: '20',
  };
  const { control, register } = useForm<Inputs>({ defaultValues });

  return (
    <>
      <FSTextField
        select
        label="FSTextField select with default value => not working"
        onChange={() => {}}
        // defaultValue={'20'}
        register={{ ...register('select1') }}
      >
        <MenuItem value={10}>Ten</MenuItem>
        <MenuItem value={20}>Twenty</MenuItem>
        <MenuItem value={30}>Thirty</MenuItem>
      </FSTextField>
      <FSSelect name="select2" control={control}>
        <MenuItem value={10}>Ten</MenuItem>
        <MenuItem value={20}>Twenty</MenuItem>
        <MenuItem value={30}>Thirty</MenuItem>
      </FSSelect>
      <Controller
        name={'select3'}
        control={control}
        render={(
          { field: { ...field } }, // remove ref to avoid console error becasue FSTextField do not received ref
        ) => (
          <FSTextField
            select
            label={'Controller + FSTextField select'}
            {...field}
          >
            <MenuItem value={10}>Ten</MenuItem>
            <MenuItem value={20}>Twenty</MenuItem>
            <MenuItem value={30}>Thirty</MenuItem>
          </FSTextField>
        )}
      />
    </>
  );
}
